

















import { Component, Vue } from 'vue-property-decorator'
import { getVasInfo } from '@/apps/open/services/vasopen'
import { IAppInfo } from '@/apps/open/store/modules/app/types'
import Sidebar from '@/apps/open/components/Sidebar'
import { compact } from 'lodash'
import store from '@/apps/open/store'
import { onRequestError } from '@/apps/open/utils'
import { FUNCTION_ID_MAP } from '@/apps/open/constants'

@Component({
  components: {
    Sidebar
  }
})
export default class AppIndex extends Vue {
  app: IAppInfo = {}
  vasInfo: any = ''

  get id () {
    return this.$route.params['id']
  }

  get isAppCreator () {
    return this.$store.getters['isAppCreator']
  }

  get isSuperAdmin () {
    return this.$store.getters['isSuperAdmin']
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get isShowCertificate () {
    return this.$store.getters['isPrivate'] && !this.$store.getters['isGeneralPrivate']
  }

  get isPriDocMiddle () {
    return this.$store.getters['isPriDocMiddle']
  }

  get isPriDocEdit () {
    return this.$store.getters['isPriDocEdit']
  }

  get isCreatorOrSuperAdmin () {
    return this.isAppCreator || this.isSuperAdmin
  }

  get companyId () {
    return this.$store.getters['App/companyId']
  }

  get tabList () {
    const authTabStatus = this.$store.getters['App/authTabStatus']
    const syncTabStatus = this.$store.getters['App/syncTabStatus']
    const callbackTabStatus = this.$store.getters['App/callbackTabStatus']
    const msgCallbackTabStatus = this.$store.getters['App/msgCallbackTabStatus']
    const docEditCallbackTabStatus = this.$store.getters['App/docEditCbTabStatus']
    const docPreviewCbTabStatus = this.$store.getters['App/docPreviewCbTabStatus']
    const docFormatCbTabStatus = this.$store.getters['App/docFormatCbTabStatus']
    const spaceConfigTabStatus = this.$store.getters['App/spaceConfigTabStatus']
    const list = [
      { text: '基本设置', routeName: 'app-setting' },
      this.isShowCertificate && { text: '证书回调', routeName: 'certificate-callback' },
      { text: '权限申请', routeName: 'app-permission' },
      { text: '应用信息', routeName: 'app-info' },
      !this.isPriDocEdit && this.app.is_sandbox && { text: '成员管理', routeName: 'app-member' },
      this.vasInfo && { text: '订单查询', routeName: 'app-order' },
      this.isCreatorOrSuperAdmin && callbackTabStatus && { text: '回调配置', routeName: 'callback-config' },
      this.isCreatorOrSuperAdmin && msgCallbackTabStatus && { text: '订阅回调', routeName: 'msg-callback-config' },
      this.isCreatorOrSuperAdmin && docEditCallbackTabStatus && { text: '编辑回调', routeName: 'doc-edit-callback-config' },
      this.isCreatorOrSuperAdmin && docPreviewCbTabStatus && { text: '预览回调', routeName: 'doc-preview-callback-config' },
      this.isCreatorOrSuperAdmin && docFormatCbTabStatus && { text: '格式回调', routeName: 'doc-format-callback-config' },
      this.isCreatorOrSuperAdmin && spaceConfigTabStatus && { text: '存储管理', routeName: 'space-config' },
      !!this.companyId && this.isCreatorOrSuperAdmin && authTabStatus && { text: '认证方式', routeName: 'app-auth' },
      !!this.companyId && this.isCreatorOrSuperAdmin && syncTabStatus && { text: '同步方式', routeName: 'app-sync' }
    ]
    return compact(list)
  }

  async loadAppInfo () {
    await this.$store.dispatch('App/GET_APP_INFO', this.id)
    this.app = this.$store.getters['App/appInfo']
    const appMode = this.$store.getters['App/appInfo'].app_mode
    await this.$store.dispatch('App/GET_APPLY_FEATURE_LIST', this.id)
    appMode === 2 && await this.$store.dispatch('App/GET_COMPANY_ID', this.id)
    // 找到是否开通了认证方式和同步方式能力，开启对应路由
    const applyFeatureList = this.$store.getters['App/applyFeatureList']
    this.$store.commit('App/SET_AUTH_TAB_STATUS', false)
    this.$store.commit('App/SET_SYNC_TAB_STATUS', false)
    this.$store.commit('App/SET_CALLBACK_TAB_STATUS', false)
    this.$store.commit('App/SET_MSG_CALLBACK_TAB_STATUS', false)
    this.$store.commit('App/SET_DOC_EDIT_CALLBACK_TAB_STATUS', false)
    this.$store.commit('App/SET_DOC_PREVIEW_CALLBACK_TAB_STATUS', false)
    this.$store.commit('App/SET_DOC_FORMAT_CALLBACK_TAB_STATUS', false)
    this.$store.commit('App/SET_SPACE_CONFIG_TAB_STATUS', false)
    applyFeatureList.forEach((i:any) => {
      if (appMode === 2) {
        if (i.function_name === (this.isPrivate ? '企业授权' : '企业内部授权') && i.status === 1) {
          this.$store.commit('App/SET_AUTH_TAB_STATUS', true)
        }
        if (i.function_name === '企业通讯录' && i.status === 1) {
          this.$store.commit('App/SET_SYNC_TAB_STATUS', true)
        }
        if (this.isPrivate && i.function_name === '消息和订阅' && i.status === 1) {
          this.$store.commit('App/SET_MSG_CALLBACK_TAB_STATUS', true)
        }
      }
      if (i.function_name === '在线编辑' && i.status === 1) {
        this.$store.commit('App/SET_DOC_EDIT_CALLBACK_TAB_STATUS', true)
      }
      if (i.function_name === '在线预览' && i.status === 1) {
        this.$store.commit('App/SET_DOC_PREVIEW_CALLBACK_TAB_STATUS', true)
      }
      if (i.function_name === '内容处理' && i.status === 1) {
        this.$store.commit('App/SET_DOC_FORMAT_CALLBACK_TAB_STATUS', true)
      }
      if (i.function_name === '应用文档协同管理' && i.status === 1) {
        this.$store.commit('App/SET_CALLBACK_TAB_STATUS', true)
      }
      if (i.function_name === '应用文档管理' && i.status === 1) {
        this.$store.commit('App/SET_SPACE_CONFIG_TAB_STATUS', true)
      }
    })
  }

  async loadVasInfo () {
    if (!this.isPrivate) {
      const res = await getVasInfo(this.id)
      this.vasInfo = res.data.data
    }
  }

  async mounted () {
    if (this.id) {
      try {
        await Promise.all([this.loadAppInfo(), this.loadVasInfo()])
      } catch (error) {
        onRequestError(error)
      }
    }
  }
}
